<template>
  <c-loader
    v-if="disabledSaved"
    class="new-calculation-loader"
    label="Производится сохранение"
    :active="disabledSaved "
    :height="500"
  />
  <div v-else class="delivery">
    <m-table-settings
      v-model="tableSettingsModal"
      :columns="tableData.columns"
      :disabled-columns="tableData.disabledColumns"
      :default-disabled-columns="tableData.defaultDisabledColumns"
      with-grouped
      @submit="submitTableSettings"
    />
    <m-production-write-fine-premium
      :calculation-type="tab"
      :calc-data="data"
      :table-records="tableData.records"
      :active="isShowModalProductionWriteFinePremium"
      :is-delivery-tab="true"
      @writeFineBonusAllWorkers="writeFineBonusAllWorkers"
      @close="isShowModalProductionWriteFinePremium = false"
    />
    <m-production-add-workers
      modal-title="Добавить водителей"
      :active="isShowModalAddWorkers"
      :workers="driversLocalItems"
      :selected="driversLocalItemsSelected"
      :table-records="tableData.records"
      :data="data"
      :is-delivery-tab="true"
      :tab="tab"
      group-code="'driver'"
      @submitWorkers="submitWorkers"
      @close="isShowModalAddWorkers = false"
    />
    <m-production-create-worker
      modal-title="Создать водителя"
      :is-delivery-tab="true"
      :active="isShowModalCreateWorker"
      :calculation-type="tab"
      :data="data"
      @createNewWorker="createNewWorker"
      @close="isShowModalCreateWorker = false"
    />
    <div class="delivery-header">
      <div class="delivery-header-buttons-left">
        <c-button-dropdown
          icon="arrow"
          type="dropdown"
          class="delivery-header-buttons-left-drivers"
          :class="{ 'delivery-header-buttons-left-drivers-disabled': dataIsLoading || !canEdit }"
          :disabled="dataIsLoading || !canEdit"
          label="Водители"
          :dropdown="{
            position: 'right',
            items: [
              { label: 'Добавить водителей', emit: 'addDrivers' },
              { label: 'Новый водитель', emit: 'createDriver' },
            ],
          }"
          @addDrivers="showModalAddDrivers"
          @createDriver="openCreateDriverModal"
        />
        <c-button
          v-if="tab !== 'byPeriod'"
          class="delivery-header-buttons-left-recalculate-routes"
          icon="routes"
          label="Пересчитать маршруты"
          :disabled="dataIsLoading"
          size="small"
          responsive
          @click="recountRoutes()"
        />
        <c-button
          class="delivery-header-buttons-left-fine-rewarding"
          :disabled="!isThereWorkersInTable || dataIsLoading || !canEdit"
          :label="tab === 'byPeriod' ? 'Штраф/премия' : 'Штраф/премия смене'"
          color="white"
          size="small"
          @click="isShowModalProductionWriteFinePremium = true"
        />
        <div v-if="false && tab !== 'byPeriod'" class="delivery-header-buttons-left-holiday-allowance">
          <c-input
            class="delivery-header-buttons-left-holiday-allowance-input"
            placeholder="Праздничная надбавка"
            type="price-number"
          />
          <div class="delivery-header-buttons-left-holiday-allowance-percent">%</div>
        </div>
      </div>
      <div class="delivery-header-buttons-right">
        <c-button
          responsive
          size="small"
          :disabled="dataIsLoading || !canEdit"
          label="Настроить столбцы"
          icon="cog"
          type="with-icon"
          @click="tableSettingsModal = true"
        />
        <c-button
          class="delivery-header-buttons-right-less"
          label="Меньше информации"
          :disabled="dataIsLoading || currentColumnLevel === 1"
          icon="less"
          color="white"
          size="small"
          @click="lessInformation"
        />
        <c-button
          class="delivery-header-buttons-right-more"
          label="Больше информации"
          :disabled="dataIsLoading || currentColumnLevel === 3"
          icon="more"
          color="white"
          size="small"
          @click="moreInformation"
        />
      </div>
    </div>
    <c-data-table-delivery
      v-if="!dataIsLoading"
      ref="table"
      class="delivery-table"
      :levels="1"
      :disabled-columns="tableData.disabledColumns"
      :data="tableData"
      :calculation-data="data"
      :calculation-type="tab"
      :is-delivery-tab="true"
      :personal-reasons="personalReasons"
      :can-edit="canEdit"
      @productionRemoveWorkerFromCalc="removeWorker"
      @updateFines="updateFines"
      @changeDriver="changeDriver"
      @recountDriver="recountDriver"
      @updateBonuses="updateBonuses"
      @updateKPItable="updateKPItable"
      @updatePersonal="updatePersonal"
    />
    <div v-if="!dataIsLoading && (canEdit || canClose || isClosed)" class="delivery-actions-row">
      <c-button
        v-if="canClose"
        size="large"
        class="delivery-actions-row__toggle-closed"
        :class="{ 'delivery-actions-row__toggle-closed--active': !isClosed }"
        :disabled="isTogglingClosed"
        :label="isClosed ? 'Открыть расчёт' : 'Закрыть расчёт'"
        :color="isClosed ? 'primary' : undefined"
        @click="$emit('toggleClosed')"
      />
      <span
        v-if="isClosed"
        class="delivery-actions-row__closed-badge"
      >Расчёт закрыт</span>
      <responsive-apply-reset-actions
        v-if="canEdit"
        class="delivery-actions"
        :class="{ 'no-shadow': !displayActionShadows }"
        :disable-submit="disabledSaved"
        @on-submit="saveCalculation"
        @on-reset="cancelCalculation"
      />
    </div>
    <c-loader
      v-if="dataIsLoading"
      class="delivery-loader"
      label="Данные загружаются"
      :active="dataIsLoading"
      height="300"
    />
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import moment from "moment";
import TableSettingsModal from "@/pages/calculations/create/additions/data-table-create-calculations-settings";
import Loader from "@/components/loader";
import DataTableCreateCalculationDelivery from "@/pages/calculations/create/additions/data-table-create-calculation-delivery";
import ModalProdactionWriteFinePremium from "@/pages/calculations/create/additions/modal-production-write-fine-premium";
import ModalProductionAddWorkers from "@/pages/calculations/create/additions/modal-production-add-workers";
import ModalProdactionCreateWorker from "@/pages/calculations/create/additions/modal-production-create-worker";
import Input from "@/components/controls2/Input";

import ButtonDropdown from "@/components/controls/button-dropdown";
import Button from "@/components/controls2/Button";
import {
  eventAddWorkerDriver,
  eventRemoveWorkerDriver,
  eventUpdateFinesDrivers,
  eventUpdateBonusesDrivers,
  eventChangeIntervalsDrivers,
  eventAddBonusFineAll,
  eventUpdatePersonalDriver,
  findPostDriver, eventRecalcDriver
} from "@/entities/models/calculations";
import ResponsiveApplyResetActions from "@/components/responsive-apply-reset-actions.vue";
import {onScrollEnd} from "@/helpers/events";

export default {
  name: "new-calculation-delivery",
  components: {
    ResponsiveApplyResetActions,
    "m-table-settings": TableSettingsModal,
    "c-button": Button,
    "c-button-dropdown": ButtonDropdown,
    "c-data-table-delivery": DataTableCreateCalculationDelivery,
    "m-production-write-fine-premium": ModalProdactionWriteFinePremium,
    "m-production-add-workers": ModalProductionAddWorkers,
    "m-production-create-worker": ModalProdactionCreateWorker,
    "c-loader": Loader,
    "c-input": Input,
  },
  props: ["data", "tab", "personalReasons", "driversColumns", "driversColumnsDisabled", "canEdit", "disabledSaved", "isClosed", "canClose", "isTogglingClosed"],
  data() {
    return {
      isThereWorkersInTable: false,
      dataIsLoading: true,
      tableSettingsModal: false,
      isShowModalAddWorkers: false,
      driversLocalItems: [],
      driversLocalItemsSelected: [],
      isShowModalProductionWriteFinePremium: false,
      isShowModalCreateWorker: false,
      tableData: {
        type: "save-calculation-delivery",
        columns: [],
        records: [],
        actions: false,
        enabledFields: [],
        levels: 1,
        disabledColumns: [],
        defaultDisabledColumns: [],
        filteredColumns: [],
        activeFilteredColumns: [],
      },
      currentColumnLevel: 3,
      columnsLevels: {
        1: {
          disabledColumns: [
            "premium_personal_account",
            "personal_account_transactions",
            "working_interval",
            "amount_working_time",
            "number_of_orders",
            "order_value",
            "average_check",
            "distance",
            "travel_time_calculation",
            "actual_travel_time",
            "time",
            "orders",
            "money_per_distance",
            "minimum_wage",
            "allowance",
            "late_checkout_surcharge",
            "short_shift_allowance",
            "prize",
            "fine",
            "sum_orders",
            "post2",
          ],
        },
        2: {
          disabledColumns: [
            "amount_working_time",
            "travel_time_calculation",
            "time",
            "orders",
            "money_per_distance",
            "minimum_wage",
            "allowance",
            "late_checkout_surcharge",
            "short_shift_allowance",
            "total_accrued",
          ],
        },
        3: {
          disabledColumns: [],
        },
      },
      displayActionShadows: true,
    };
  },
  computed: {
    ...mapGetters("calculations", ["getTableDeliveryCreateCalculation", "getTableDeliveryByPeriod"]),
  },

  watch: {
    "tableData.records": {
      deep: true,
      handler(value) {
        let countWorkersInTable = 0;
        value.forEach((record) => {
          if (!record.isTotalRow) countWorkersInTable += 1;
        });
        if (countWorkersInTable > 0) {
          this.isThereWorkersInTable = true;
        } else {
          this.isThereWorkersInTable = false;
        }
      },
    },

    "data": function (value) {
      if (this.tab === "byDate") {
        this.tableData.disabledColumns = [
          ...this.getTableDeliveryCreateCalculation.columns
            .filter((item) => {
              const driversColumnsArray = Object.values(this.driversColumns || {});
              return !driversColumnsArray.includes(item.id);
            })
            .map((s) => s.id),
        ];

        this.tableData.columns = [...this.getTableDeliveryCreateCalculation.columns];

        if(this.data.is_filial_admin) {
          this.tableData.columns = this.tableData.columns.filter((item) => item.id !== 'distance');
        }

        this.tableData.records = [...this.getTableDeliveryCreateCalculation.records];
      } else {
        this.tableData.columns = [...this.getTableDeliveryByPeriod.columns];

        if(this.data.is_filial_admin) {
          this.tableData.columns = this.tableData.columns.filter((item) => item.id !== 'distance');
        }

        this.tableData.records = [...this.getTableDeliveryByPeriod.records];
      }

      if (this.tab === "byDate") {
        this.reinitRecordsByDate();

      } else {
        const calcWorkers = value.period.drivers.workers;

        calcWorkers.forEach((worker) => {
          const findReferenceDataWorker = value.allDrivers[worker.worker_id];
          const defaultPersonalHistory = [
            {
              amount: Math.round(worker.personal),
              authorName: "vpadmin",
              comment: null,
              reason: null,
              reason_id: null,
            },
          ];
          if (findReferenceDataWorker !== undefined) {
            this.tableData.records.push({
              id: worker.worker_id,
              codeGroup: "driver",
              personalAmount: findReferenceDataWorker.personal_amount,
              employee: {
                value: worker.showname,
              },
              post2: {
                value: '', // worker.showname,
              },
              doc_problem: findReferenceDataWorker.doc_problem,
              recommened_category: 0,
              premium_personal_account: {
                value: `${Math.round(findReferenceDataWorker.personal_amount)}`,
              },
              personal_account_transactions: {
                value: worker.personal,
                items:
                  worker.personal_history && worker.personal_history.length > 0
                    ? worker.personal_history
                    : defaultPersonalHistory,
              },
              account_accrued: Math.round(worker.sum),
              account_removed: Math.round(worker.sum_prepay),
              account_balance: Math.round(worker.personal),

              personal_account_accrued: {
                value: Math.round(worker.sum),
              },
              personal_account_removed: {
                value: worker.sum_prepay,
              },
              balance: {
                value: Math.round(worker.balance),
              },
              sum_deposit: {
                value: Math.round(worker.sum_deposit),
              },
              
              personal_account_balance: {
                value: worker.personal,
              },
              count_smenas: {
                value: worker.count_smenas,
              },
              period_working_time: {
                value: this.convertHoursToHHMM(worker.worktime),
              },
              worktime: worker.worktime,

              order_value: {
                value: Math.round(worker.orders_sum),
              },
              average_check: {
                value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
              },
              travel_time_calculation: {
                value: this.convertHoursToHHMM(worker.plan_duration),
                valueInDecimal: worker.plan_duration,
              },
              actual_travel_time: {
                value: this.convertHoursToHHMM(worker.duration),
                valueInDecimal: worker.duration,
              },
              kpi: {
                value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
              },
              idle_time: {
                value:
                  worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
              },
              time: {
                value: Math.round(Number(worker.sum_duration)),
              },
              orders: {
                value: worker.orders,
              },
              distance: {
                value: Math.round(worker.distance*100)/100,
              },
              money_per_distance: {
                value: Math.round(worker.sum_distance),
              },
              sum_orders: {
                value: Math.round(worker.sum_orders),
              },
              minimum_wage: {
                value: worker.sum_min,
              },
              allowance: {
                value: worker.sum_surcharge !== 0 ? Number(worker.sum_surcharge).toFixed(2) : 0,
              },
              late_checkout_surcharge: {
                value: worker.sum_departure,
              },
              short_shift_allowance: {
                value: worker.sum_short_shift,
              },
              prize: {
                value: worker.sum_bonus,
                items: worker.bonuses,
              },
              fine: {
                value: worker.sum_penalty,
                items: worker.fines,
              },
              total_accrued: {
                value: Math.round(worker.sum),
              },
              already_paid: {
                value: Math.round(worker.sum_prepay) * -1,
              },
              to_payoff: {
                value: Math.round(worker.sum_paid),
              },
              isShowRow: true,
            });
          } else {
            this.tableData.records.push({
              id: worker.worker_id,
              codeGroup: "driver",
              personalAmount: 0,
              employee: {
                value: worker.showname,
              },
              post2: {
                value: worker.post2,
              },
              doc_problem: "",
              recommened_category: 0,
              premium_personal_account: {
                value: "0",
              },
              personal_account_transactions: {
                value: worker.personal,
                items:
                  worker.personal_history && worker.personal_history.length > 0
                    ? worker.personal_history
                    : defaultPersonalHistory,
              },
              sum_deposit: {
                value: Math.round(worker.sum_deposit),
              },

              personal_account_balance: {
                value: worker.personal,
              },
              count_smenas: {
                value: worker.count_smenas,
              },
              period_working_time: {
                value: this.convertHoursToHHMM(worker.worktime),
              },
              worktime: worker.worktime,

              order_value: {
                value: Math.round(worker.orders_sum),
              },
              average_check: {
                value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
              },
              travel_time_calculation: {
                value: this.convertHoursToHHMM(worker.plan_duration),
                valueInDecimal: worker.plan_duration,
              },
              actual_travel_time: {
                value: this.convertHoursToHHMM(worker.duration),
                valueInDecimal: worker.duration,
              },
              kpi: {
                value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
              },
              idle_time: {
                value:
                  worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
              },
              time: {
                value: Math.round(Number(worker.sum_duration)),
              },
              orders: {
                value: Math.round(worker.orders),
              },
              distance: {
                value: Math.round(worker.distance*100)/100,
              },
              money_per_distance: {
                value: Math.round(worker.sum_distance),
              },
              sum_orders: {
                value: Math.round(worker.sum_orders),
              },
              minimum_wage: {
                value: Math.round(worker.sum_min),
              },
              allowance: {
                value: worker.sum_surcharge !== 0 ? Number(worker.sum_surcharge).toFixed(2) : 0,
              },
              late_checkout_surcharge: {
                value: Math.round(worker.sum_departure),
              },
              short_shift_allowance: {
                value: Math.round(worker.sum_short_shift),
              },
              prize: {
                value: Math.round(worker.sum_bonus),
                items: worker.bonuses,
              },
              fine: {
                value: Math.round(worker.sum_penalty),
                items: worker.fines,
              },
              account_accrued: Math.round(worker.plus),
              account_removed: Math.round(worker.minus),
              account_balance: Math.round(worker.personal),
              plus: Math.round(worker.plus),
              minus: Math.round(worker.minus),
              personal_account_accrued: {
                value: Math.round(worker.plus),
              },
              personal_account_removed: {
                value: Math.round(worker.minus),
              },
              balance: {
                value: typeof worker.balance==='object' ? worker.balance.value : Math.round(worker.balance),
              },
              total_accrued: {
                value: Math.round(worker.plus),
              },
              already_paid: {
                value: Math.round(worker.minus) * -1,
              },
              to_payoff: {
                value: Math.round(worker.balance), // -Math.round(worker.personal)  //Math.round(worker.sum_paid),
              },

              isShowRow: true,
            });
          }
        });

        this.tableData.records.map((w)=>{
          // g.records.map((w)=>{
          let sumFines = 0; let sumPrizes = 0;
          if (!w.prize.items) w.prize.items = [];
          w.prize.items.forEach((item) => {
            if (!item.is_external) sumPrizes += Number(item.amount);
          });
          if (!w.fine.items) w.fine.items = [];
          w.fine.items.forEach((item) => {
            if (!item.is_external) sumFines += Number(item.amount);
          });

          let minus = 0; let plus = 0;
          if (w.personal_account_transactions.items) {
            w.personal_account_transactions.items.map((t)=>{
              if (t.type=="-") minus+=Number(t.amount); else plus+=Number(t.amount);
            });
          }
          w.personal_account_transactions.value = plus-minus;
          w.total_accrued.value = Number(w.account_accrued) + plus + sumPrizes;
          w.already_paid.value = Number(w.account_removed) + minus + sumFines;

          w.to_payoff.value = Number(w.balance.value) + plus - minus + sumPrizes - sumFines;
          w.personal_account_balance.value = w.premium_personal_account.value;
          w.personal_account_balance_start = w.premium_personal_account.value - plus + minus;
        });

        this.calculateTotalRow();
      }
      
      this.dataIsLoading = false;
    },

    "tableData.disabledColumns": function (value) {
      this.$emit("disabledColumnsEvent", {c:value, t:"driver"});

      if (value.length === 0) {
        this.currentColumnLevel = 3;
      }
      if (
        value === this.columnsLevels[2].disabledColumns ||
        (value.length !== 0 && value.length < this.columnsLevels[2].disabledColumns.length)
      ) {
        this.currentColumnLevel = 2;
      }
      if (
        value === this.columnsLevels[1].disabledColumns ||
        value.length >= this.columnsLevels[1].disabledColumns.length
      ) {
        this.currentColumnLevel = 1;
      }
    },
  },

  async created() {
    this.tableData.disabledColumns=this.driversColumnsDisabled;
  },

  mounted() {
    const layout = document.querySelector(".layout");
    layout.addEventListener("scroll", this.handleScroll);
  },

  beforeDestroy() {
    window.removeEventListener('scroll', this.handleScroll);
  },

  methods: {
    handleScroll() {
      this.displayActionShadows = true;

      onScrollEnd(async () => {
        this.displayActionShadows = false;
      });
    },

    changeDriver(record) {
      this.$emit("changeDriver", record);
    },

    recountDriver(record) {
      const c = this.data.calc.calculation;
      this.$store
        .dispatch("calculations/recalcDriver", {
          id: c.filial_id,
          driverID : record.id,
          date: c.date,
          timebeg: c.timebeg,
          timeend: c.timeend
        })
        .then(res => {
          eventRecalcDriver(res, this.data);
          this.reinitRecordsByDate();
        });
      this.$emit("recountDriver", record);
    },

    recountRoutes(){
      this.$emit("recountRoutes");
    },

    salmon(v){},
    loadvalue(v){},

    recountPersonalPeriod(record) {
      let minus=0; let plus=0;
      record.personal_account_transactions.items.forEach((item) => {
        if (item.type=='+') {
          plus += Number(item.amount);
        } else {
          minus += Number(item.amount);          
        }
      }); 

      let sumFines = 0; let sumPrizes = 0;
      record.prize.items.forEach((item) => {
        if (!item.is_external) sumPrizes += Number(item.amount);
      });
      record.fine.items.forEach((item) => {
        if (!item.is_external) sumFines += Number(item.amount);
      });

      record.to_payoff.value =Number(record.balance.value) + plus - minus + sumPrizes - sumFines; // к выплате
      record.total_accrued.value =Number(record.personal_account_accrued.value) + plus + sumPrizes; // всего начислено
      record.already_paid.value =Number(record.personal_account_removed.value) + minus + sumFines; // всего списано
      record.personal_account_balance.value = record.personal_account_balance_start + plus - minus;// - minus + sumPrizes - sumFines; остаток на лс 

      record.to_payoff.value = Math.round(record.to_payoff.value*100)/100;
      record.total_accrued.value = Math.round(record.total_accrued.value*100)/100;
      record.already_paid.value = Math.round(record.already_paid.value*100)/100;
      record.personal_account_balance.value = Math.round(record.personal_account_balance.value*100)/100;

      this.updateKPItable();
    },

    updateKPItable() {
      this.calculateTotalRow();
      this.$emit("updateKPItable");
    },

    updateFines(params) {
      if (this.tab === "byPeriod") {
        this.recountPersonalPeriod(params.record);

      } else {
        const w = params.record;
        eventUpdateFinesDrivers(w.id, w.fine.items, this.data);
        this.reinitRecordsByDate();
      }
    },

    updatePersonal(params) {
      if (this.tab === "byPeriod") {
      } else {
        const w = params.record;
        eventUpdatePersonalDriver(w.id, w.personal_account_transactions.items, this.data);
        this.reinitRecordsByDate();
      }
    },

    updateBonuses(params) {
      if (this.tab === "byPeriod") {
        this.recountPersonalPeriod(params.record);

      } else {
        const w = params.record;
        eventUpdateBonusesDrivers(w.id, w.prize.items, this.data);
        this.reinitRecordsByDate();
      }
    }, 

    changeIntervals(w, i) {
      if (this.tab === "byPeriod") {
      } else {
        eventChangeIntervalsDrivers(w.id, i, this.data);
        this.reinitRecordsByDate();
      }
    },

    reinitRecordsByDate() {
      this.tableData.records = [...this.getTableDeliveryCreateCalculation.records];
      const calcWorkers = this.data.calc.drivers.workers;
      const value = this.data;

      calcWorkers.forEach((worker) => {
        let post = findPostDriver(worker.post_code, this.data.calc); if (!post) post=findPostDriver("driver", this.data.calc);
        const findReferenceDataWorker = value.drivers[worker.worker_id];

        const defaultPersonalHistory = [
          {
            amount: 0,
            authorName: "vpadmin",
            comment: null,
            reason: null,
            reason_id: null,
          },
        ];

        if (findReferenceDataWorker !== undefined) {

          this.tableData.records.push({
            id: worker.worker_id,
            codeGroup: "driver",
            employee: {
              value: worker.showname,
            },
            post2 : {
              value: post.name,
            },
            sum_deposit: {
              value: worker.sum_deposit ? worker.sum_deposit : '',
            },
            doc_problem: findReferenceDataWorker.doc_problem,
            recommened_category: 0,
            premium_personal_account: {
              value: `${findReferenceDataWorker.personal_amount}`,
            },
            personal_account_transactions: {
              value: -worker.personal,
              items:
                worker.personal_history && worker.personal_history.length > 0
                  ? worker.personal_history
                  : defaultPersonalHistory,
            },
            working_interval: {
              value: worker.intervals,
            },
            amount_working_time: {
              value: this.convertHoursToHHMM(worker.worktime),
            },
            worktime: worker.worktime,

            number_of_orders: {
              value: worker.orders,
            },
            order_value: {
              value: Math.round(worker.orders_sum),
            },
            average_check: {
              value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
            },
            travel_time_calculation: {
              value: this.convertHoursToHHMM(worker.plan_duration),
              valueInDecimal: worker.plan_duration,
            },
            actual_travel_time: {
              value: this.convertHoursToHHMM(worker.duration),
              valueInDecimal: worker.duration,
            },
            kpi: {
              value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
            },
            idle_time: {
                   
              value:
                worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
            },
            time: {
              value: Math.round(worker.sum_duration),
            },
            orders: {
              value: Math.round(worker.sum_orders),
            },
            distance: {
              value: Math.round(worker.distance*100)/100,
            },
            money_per_distance: {
              value: Math.round(worker.sum_distance),
            },
            sum_orders: {
              value: Math.round(worker.sum_orders),
            },
            minimum_wage: {
              value: Math.round(worker.sum_min),
            },
            allowance: {
              value: worker.sum_surcharge,
            },
            late_checkout_surcharge: {
              value: worker.sum_departure,
            },
            short_shift_allowance: {
              value: worker.sum_short_shift,
            },
            prize: {
              value: worker.sum_bonus,
              items: worker.bonuses,
            },
            fine: {
              value: worker.sum_penalty,
              items: worker.fines,
            },
            total_accrued: {
              value: Math.round(worker.sum),
            },
            to_payoff: {
              value: Math.round(worker.sum_paid),
            },
            isShowRow: true,
          });
        } else {

          this.tableData.records.push({
            id: worker.worker_id,
            codeGroup: "driver",
            employee: {
              value: worker.showname,
            },
            sum_deposit: {
              value: worker.sum_deposit ? worker.sum_deposit : '',
            },
            post2 : {
              value: post.name,
            },
            doc_problem: "",
            recommened_category: 0,
            premium_personal_account: {
              value: "0",
            },
            personal_account_transactions: {
              value: -worker.personal,
              items:
                worker.personal_history && worker.personal_history.length > 0
                  ? worker.personal_history
                  : defaultPersonalHistory,
            },
            working_interval: {
              value: worker.intervals,
            },
            amount_working_time: {
              value: this.getAmountWorkerTime(worker.intervals),
            },
            number_of_orders: {
              value: worker.orders,
            },
            order_value: {
              value: worker.sum_orders,
            },
            average_check: {
              value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
            },
            travel_time_calculation: {
              value: this.convertHoursToHHMM(worker.plan_duration),
              valueInDecimal: worker.plan_duration,
            },
            actual_travel_time: {
              value: this.convertHoursToHHMM(worker.duration),
              valueInDecimal: worker.duration,
            },
            kpi: {
              value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
            },
            idle_time: {
              value:
                worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
            },
            worktime: worker.worktime,

            time: {
              value: worker.sum_duration,
            },
            orders: {
              value: worker.sum_orders,
            },
            distance: {
              value: Math.round(worker.distance*100)/100,
            },
            money_per_distance: {
              value: Math.round(worker.sum_distance),
            },
            sum_orders: {
              value: Math.round(worker.sum_orders),
            },
            minimum_wage: {
              value: Math.round(worker.sum_min),
            },
            allowance: {
              value: worker.sum_surcharge,
            },
            late_checkout_surcharge: {
              value: worker.sum_departure,
            },
            short_shift_allowance: {
              value: worker.sum_short_shift,
            },
            prize: {
              value: worker.sum_bonus,
              items: worker.bonuses,
            },
            fine: {
              value: worker.sum_penalty,
              items: worker.fines,
            },
            total_accrued: {
              value: Math.round(worker.sum),
            },
            to_payoff: {
              value: Math.round(worker.sum_round),
            },
            isShowRow: true,
          });
        }
      });

      this.calculateTotalRow();
    },
    submitTableSettings() {
      if (this.columns.length === 0) {
        this.tableData.disabledColumns = [];
      }
      if (this.$refs.table) this.$refs.table.scroll();
    },
    removeWorker(workerId) {
      if (this.tab === "byDate") {
        eventRemoveWorkerDriver(workerId.id, this.data);
        this.reinitRecordsByDate();
        return "6";
      }

      const c = this.tableData.records.findIndex((record) => record.id === workerId.id);
      if (c !== -1) {
        this.tableData.records.splice(c, 1);
        // this.updateKPItable();
        this.calculateTotalRow();
      }
      this.$emit("updateDriversCount", this.tableData.records.length);
    },
    getAmountWorkerTime(intervals) {
      let sumHoursWorked = 0;
      intervals.forEach((interval) => {
        const start = moment(interval.start);
        const end = moment(interval.finish);
        const duration = moment.duration(end.diff(start)).asHours();
        sumHoursWorked += duration;
      });
      this.sumHoursWorked = sumHoursWorked;
      const n = new Date(0, 0);
      n.setSeconds(+sumHoursWorked * 60 * 60);
      return n.toTimeString().slice(0, 5);
    },
    convertHoursToHHMM(decimalTimeString) {
      let decimalTime = parseFloat(decimalTimeString);
      decimalTime = decimalTime * 60 * 60;
      let hours = Math.floor(decimalTime / (60 * 60));
      decimalTime -= hours * 60 * 60;
      let minutes = Math.floor(decimalTime / 60);
      if (hours < 10) {
        hours = `0${hours}`;
      }
      if (minutes < 10) {
        minutes = `0${minutes}`;
      }
      return `${hours}:${minutes}`;
    },
    lessInformation() {
      if (this.currentColumnLevel > 1) {
        this.currentColumnLevel -= 1;
        this.tableData.disabledColumns = [...this.columnsLevels[this.currentColumnLevel].disabledColumns];
        if (this.$refs.table) this.$refs.table.scroll(1, true);
      }
    },

    moreInformation() {
      if (this.currentColumnLevel < 3) {
        this.currentColumnLevel += 1;
        this.tableData.disabledColumns = [...this.columnsLevels[this.currentColumnLevel].disabledColumns];
        if (this.$refs.table) this.$refs.table.scroll(1, true);
      }
    },
    writeFineBonusAllWorkers(params) {
      if (this.tab !== "byPeriod") {
        eventAddBonusFineAll(
          params.type == "premium" ? "bonus" : "fine",
          params.category.value == "delivery" ? "drivers" : "production",
          {
            amount : parseFloat(params.amount),
            id : null,
            reason_id : params.basis.value,
            reason : params.basis.label,
            author_id : params.author ? params.author.value : null
          },
          this.data
        );
        this.reinitRecordsByDate();
        return;    
      }  
      this.tableData.records.forEach((record) => {
        if (!record.isTotalRow) {
          if (params.type === "fine") {
            record.fine.items.push({
              amount: params.amount,
              author_id: params.author ? params.author.value : null,
              reason: params.basis.label,
              reason_id: params.basis.value,
              comment: params.comment,
              is_external: false,
            });
            record.fine.value = Number(record.fine.value) + Number(params.amount);

            /* let sumFines = 0;
            let sumPrizes = 0;
            record.prize.items.forEach((item) => {
              if (!item.is_external) sumPrizes += Number(item.amount);
            });
            record.fine.items.forEach((item) => {
              if (!item.is_external) sumFines += Number(item.amount);
            });
            record.to_payoff.value =
              Number(record.personal_account_transactions.value) + Number(sumPrizes) - Number(sumFines);
            this.calculateTotalRow(); */

          } else {
            record.prize.items.push({
              amount: params.amount,
              author_id: params.author ? params.author.value : null,
              reason: params.basis.label,
              reason_id: params.basis.value,
              comment: params.comment,
              is_external: false,
            });
            record.prize.value = Number(record.prize.value) + Number(params.amount);

            /* let sumFines = 0;
            let sumPrizes = 0;
            record.prize.items.forEach((item) => {
              if (!item.is_external) sumPrizes += Number(item.amount);
            });
            record.fine.items.forEach((item) => {
              if (!item.is_external) sumFines += Number(item.amount);
            });
            record.to_payoff.value =
              Number(record.personal_account_transactions.value) + Number(sumPrizes) - Number(sumFines);
            */
          }
          this.recountPersonalPeriod(record);
          this.calculateTotalRow();
        }
      });
    },
    submitWorkers(workers) {
      if (this.tab === "byDate") {
        const params = workers;
        params.selected.map((key) => {
          const index = this.data.calc.drivers.workers.findIndex((w) => w.worker_id.toString() == key);
          if (index==-1) {
            eventAddWorkerDriver(key, this.data);
          }
        });

        this.data.calc.drivers.workers.map((w) => {
          const index = params.selected.findIndex((key) => w.worker_id.toString() == key);
          if (index==-1) {
            eventRemoveWorkerDriver(w.worker_id, this.data);
          }
        });
        this.reinitRecordsByDate();
        return;
      } 
      this.tableData.records = [...this.getTableDeliveryByPeriod.records];
      
      workers.workers.forEach((driver) => {
        if (driver.isActive) {
          this.tableData.records.push(driver);
        }
      });
      this.calculateTotalRow();
      this.$emit("updateDriversCount", this.tableData.records.length);
    },
    createNewWorker(worker) {
      const defaultPersonalHistory = [
        {
          amount: Math.round(worker.personal),
          authorName: "vpadmin",
          comment: null,
          reason: null,
          reason_id: null,
        },
      ];
      if (this.tab === "byDate") {
        eventAddWorkerDriver(worker.key, this.data);
        this.reinitRecordsByDate();
        return;
      } 
      this.tableData.records.push({
        id: worker.worker_id,
        codeGroup: "driver",
        personalAmount: 0,
        employee: {
          value: worker.showname,
        },
        doc_problem: "Не добавлены обязательные документы",
        recommened_category: 0,
        premium_personal_account: {
          value: `${0}`,
        },
        account_accrued: Math.round(worker.sum*100)/100,
        account_removed: Math.round(worker.sum_prepay*100)/100,
        account_balance: Math.round(worker.personal*100)/100,
          
        personal_account_transactions: {
          value: worker.personal,
          items:
            worker.personal_history && worker.personal_history.length > 0
              ? worker.personal_history
              : defaultPersonalHistory,
        },
        personal_account_accrued: {
          value: Math.round(worker.sum*100)/100,
        },
        personal_account_removed: {
          value: worker.sum_prepay,
        },
        balance: {
          value: Math.round(worker.balance*100)/100,
        },
        sum_deposit: {
          value: Math.round(worker.sum_deposit),
        },

        personal_account_balance: {
          value: worker.personal,
        },
        count_smenas: {
          value: worker.count_smenas,
        },
        period_working_time: {
          value: this.convertHoursToHHMM(worker.worktime),
        },
        worktime: worker.worktime,

        order_value: {
          value: worker.sum_orders,
        },
        average_check: {
          value: worker.orders_sum !== 0 ? Math.round(worker.orders_sum / worker.orders) : 0,
        },
        travel_time_calculation: {
          value: this.convertHoursToHHMM(worker.plan_duration),
          valueInDecimal: worker.plan_duration,
        },
        actual_travel_time: {
          value: this.convertHoursToHHMM(worker.duration),
          valueInDecimal: worker.duration,
        },
        kpi: {
          value: worker.duration > 0 ? Math.round((worker.plan_duration / worker.duration) * 10 * 10) / 10 : 0,
        },
        idle_time: {
          value: worker.worktime > 0 ? Math.round(((worker.worktime - worker.duration) / worker.worktime) * 100) : 0,
        },
        time: {
          value: Math.round(Number(worker.sum_duration)),
        },
        orders: {
          value: worker.orders,
        },
        distance: {
          value: Math.round(worker.distance*100)/100,
        },
        money_per_distance: {
          value: Math.round(worker.sum_distance),
        },
        sum_orders: {
          value: Math.round(worker.sum_orders),
        },
        minimum_wage: {
          value: Math.round(worker.sum_min),
        },
        allowance: {
          value: worker.sum_surcharge !== 0 ? Number(worker.sum_surcharge).toFixed(2) : 0,
        },
        late_checkout_surcharge: {
          value: worker.sum_departure,
        },
        short_shift_allowance: {
          value: worker.sum_short_shift,
        },
        prize: {
          value: worker.sum_bonus,
          items: worker.bonuses,
        },
        fine: {
          value: worker.sum_penalty,
          items: worker.fines,
        },
        total_accrued: {
          value: Math.round(worker.sum*100)/100,
        },
        already_paid: {
          value: Math.round(worker.sum_prepay*100)/100 * -1,
        },
        to_payoff: {
          value: Math.round(worker.sum_paid*100)/100,
        },
        isShowRow: true,
      });
      
      this.calculateTotalRow();
    },
    openCreateDriverModal() {
      if (!this.canEdit) {
        return;
      }
      this.isShowModalCreateWorker = true;
    },

    showModalAddDrivers() {
      if (!this.canEdit) {
        return;
      }
      if (this.tab === "byDate") {

        /* this.productionAddWorkersModalItems = workersNotIncludedCalc; 
        this.productionAddWorkersModalItemsSelected = [];
        Object.entries(this.data.calc.production.workers).forEach( ([key, w]) => {
          if (w.post_code==groupPostCode) {
            this.productionAddWorkersModalItemsSelected.push(w.worker_id+"-"+w.post_code)
          }
        }) */ 

        const workersNotIncludedCalc = [];
        const { workers } = this.data.calc.drivers;

        Object.entries(this.data.allDrivers).forEach(([workerId, workerData]) => {
          workersNotIncludedCalc.push({
            is_filial: true,
            key: workerData.id.toString(),
            showname: workerData.name,
            worker_id: workerData.id,
          });
        });
        Object.entries(workers).forEach(([workerId, workerData]) => {
          const s = workersNotIncludedCalc.findIndex((s)=>s.worker_id==workerData.worker_id);
          if (s==-1)
            workersNotIncludedCalc.push({
              is_filial: true,
              key: workerData.worker_id.toString(),
              showname: workerData.showname,
              worker_id: workerData.worker_id,
            });
        });

        this.driversLocalItems = workersNotIncludedCalc;

        this.driversLocalItemsSelected = [];
        Object.entries(this.data.calc.drivers.workers).forEach(([key, w]) => {
          this.driversLocalItemsSelected.push(w.worker_id.toString());
        });

      } else {
        const workersNotIncludedCalc = [];
        let { workers } = this.data.period.drivers;

        Object.entries(this.data.allDrivers).forEach(([workerId, workerData]) => {
          const c = workers.findIndex((worker) => worker.worker_id.toString() === workerId.toString());
          if (c === -1)
            workersNotIncludedCalc.push({
              is_filial: workerData.is_filial,
              author_bonus: 0,
              author_fine: 0,
              bonus_id: 0,
              bonuses: workerData.bonuses,
              count_smenas: 0,
              departure: 0,
              distance: 0,
              duration: 0,
              fine_id: 0,
              fines: workerData.fines,
              orders: 0,
              orders_sum: 0,
              personal: 0,
              personalAmount: workerData.personal_amount,
              personal_history: [],
              plan_duration: 0,
              reason_surcharge_id: null,
              routes: 0,
              showname: workerData.name,
              sum: 0,
              sum_bonus: 0,
              sum_calc: 0,
              sum_departure: 0,
              sum_deposit: 0,
              sum_distance: 0,
              sum_duration: 0,
              sum_min: 0,
              sum_orders: 0,
              sum_paid: 0,
              sum_penalty: 0,
              sum_prepay: 0,
              balance: 0, 
              sum_deposit: 0,
              sum_round: 0,
              sum_short_shift: 0,
              sum_surcharge: 0,
              worker_id: workerId,
              worktime: 0,
            });
          else {
            workers[c].is_filial=workerData.is_filial;
          }
          
        });

        workers = workers.concat(workersNotIncludedCalc);

        this.driversLocalItems = JSON.parse(JSON.stringify(workers));
      }

      this.isShowModalAddWorkers = true;
    },
    calculateTotalRow() {
      if (this.tab === "byDate") {
        const findTotalRowIndex = this.tableData.records.findIndex((record) => record.isTotalRow);
        if (findTotalRowIndex !== -1) {
          this.tableData.records[findTotalRowIndex].amount_working_time.value = "00:00";
          this.tableData.records[findTotalRowIndex].number_of_orders.value = 0;
          this.tableData.records[findTotalRowIndex].order_value.value = 0;
          this.tableData.records[findTotalRowIndex].average_check.value = 0;
          this.tableData.records[findTotalRowIndex].travel_time_calculation.value = "00:00:00";
          this.tableData.records[findTotalRowIndex].actual_travel_time.value = "00:00:00";
          this.tableData.records[findTotalRowIndex].kpi.value = 0;
          this.tableData.records[findTotalRowIndex].idle_time.value = 0;
          this.tableData.records[findTotalRowIndex].time.value = 0;
          this.tableData.records[findTotalRowIndex].sum_orders.value = 0;
          this.tableData.records[findTotalRowIndex].money_per_distance.value = 0;
          // this.tableData.records[findTotalRowIndex].sum_orders.value = 0;
          this.tableData.records[findTotalRowIndex].distance.value = 0;
          this.tableData.records[findTotalRowIndex].late_checkout_surcharge.value = 0;
          this.tableData.records[findTotalRowIndex].short_shift_allowance.value = 0;
          this.tableData.records[findTotalRowIndex].prize.value = 0;
          this.tableData.records[findTotalRowIndex].fine.value = 0;
          this.tableData.records[findTotalRowIndex].total_accrued.value = 0;
          this.tableData.records[findTotalRowIndex].to_payoff.value = 0;
          this.tableData.records[findTotalRowIndex].sum_deposit.value = 0;

        }

        this.tableData.records.forEach((record) => {
          if (!record.isTotalRow) {
            this.tableData.records[findTotalRowIndex].amount_working_time.value = this.sumTime(
              this.tableData.records[findTotalRowIndex].amount_working_time.value,
              record.amount_working_time.value,
            );
            this.tableData.records[findTotalRowIndex].number_of_orders.value += record.number_of_orders.value;
            this.tableData.records[findTotalRowIndex].order_value.value += record.order_value.value;
            // this.tableData.records[findTotalRowIndex].average_check.value += record.average_check.value;
            this.tableData.records[findTotalRowIndex].travel_time_calculation.value = this.sumTime(
              this.tableData.records[findTotalRowIndex].travel_time_calculation.value,
              record.travel_time_calculation.value,
            );
            this.tableData.records[findTotalRowIndex].actual_travel_time.value = this.sumTime(
              this.tableData.records[findTotalRowIndex].actual_travel_time.value,
              record.actual_travel_time.value,
            );
            this.tableData.records[findTotalRowIndex].kpi.value += record.kpi.value;
            this.tableData.records[findTotalRowIndex].idle_time.value += record.idle_time.value;
            this.tableData.records[findTotalRowIndex].time.value += record.time.value;
            this.tableData.records[findTotalRowIndex].sum_orders.value += record.sum_orders.value;
            this.tableData.records[findTotalRowIndex].money_per_distance.value += record.money_per_distance.value;
            //  this.tableData.records[findTotalRowIndex].sum_orders.value += record.sum_orders.value;

            this.tableData.records[findTotalRowIndex].distance.value += record.distance.value;
            this.tableData.records[findTotalRowIndex].late_checkout_surcharge.value +=
              record.late_checkout_surcharge.value;
            this.tableData.records[findTotalRowIndex].short_shift_allowance.value += record.short_shift_allowance.value;
            this.tableData.records[findTotalRowIndex].prize.value += record.prize.value;
            this.tableData.records[findTotalRowIndex].fine.value += record.fine.value;
            this.tableData.records[findTotalRowIndex].total_accrued.value += record.total_accrued.value;
            this.tableData.records[findTotalRowIndex].to_payoff.value += record.to_payoff.value;
            this.tableData.records[findTotalRowIndex].sum_deposit.value += record.sum_deposit.value;

          }
        });

        this.tableData.records[findTotalRowIndex].average_check.value = this.data.calc.drivers.orders>0 ? Math.round(this.tableData.records[findTotalRowIndex].order_value.value/this.data.calc.drivers.orders) : 0;
        this.tableData.records[findTotalRowIndex].distance.value = this.tableData.records[findTotalRowIndex].distance.value.toFixed(2);

        const {worktime} = this.data.calc.drivers;
        const {duration} = this.data.calc.drivers;
        this.tableData.records[findTotalRowIndex].idle_time.value = worktime>0 ? ((worktime - duration)/worktime*100).toFixed(2) : 0;
        const {plan_duration} = this.data.calc.drivers;
        this.tableData.records[findTotalRowIndex].kpi.value = duration>0 ? (plan_duration / duration * 10).toFixed(1) : 0;
      } else {
        const findTotalRowIndex = this.tableData.records.findIndex((record) => record.isTotalRow);
        if (findTotalRowIndex !== -1) {
          this.tableData.records[findTotalRowIndex].personal_account_balance.value = 0;
          this.tableData.records[findTotalRowIndex].period_working_time.value = "00:00";
          this.tableData.records[findTotalRowIndex].order_value.value = 0;
          this.tableData.records[findTotalRowIndex].average_check.value = 0;
          this.tableData.records[findTotalRowIndex].travel_time_calculation.value = "00:00:00";
          this.tableData.records[findTotalRowIndex].actual_travel_time.value = "00:00:00";
          this.tableData.records[findTotalRowIndex].kpi.value = 0;
          this.tableData.records[findTotalRowIndex].idle_time.value = 0;
          // this.tableData.records[findTotalRowIndex].sum_orders.value = 0;
          this.tableData.records[findTotalRowIndex].money_per_distance.value = 0;
          this.tableData.records[findTotalRowIndex].time.value = 0;
          this.tableData.records[findTotalRowIndex].orders.value = 0;
          this.tableData.records[findTotalRowIndex].distance.value = 0;
          this.tableData.records[findTotalRowIndex].late_checkout_surcharge.value = 0;
          this.tableData.records[findTotalRowIndex].short_shift_allowance.value = 0;
          this.tableData.records[findTotalRowIndex].prize.value = 0;
          this.tableData.records[findTotalRowIndex].fine.value = 0;
          this.tableData.records[findTotalRowIndex].total_accrued.value = 0;
          this.tableData.records[findTotalRowIndex].already_paid.value = 0;
          this.tableData.records[findTotalRowIndex].to_payoff.value = 0;
          this.tableData.records[findTotalRowIndex].personal_account_accrued.value =0;
          this.tableData.records[findTotalRowIndex].personal_account_removed.value =0;
          this.tableData.records[findTotalRowIndex].balance.value =0;
          this.tableData.records[findTotalRowIndex].personal_account_transactions.value =0;

          this.tableData.records[findTotalRowIndex].count_smenas.value=0;
          this.tableData.records[findTotalRowIndex].sum_deposit.value=0;
          this.tableData.records[findTotalRowIndex].allowance.value=0;

        }

        this.tableData.records.forEach((record) => {

          if (!record.isTotalRow) {
            this.tableData.records[findTotalRowIndex].personal_account_balance.value += Number(
              record.personal_account_balance.value,
            );
            this.tableData.records[findTotalRowIndex].period_working_time.value = this.sumTime(
              this.tableData.records[findTotalRowIndex].period_working_time.value,
              record.period_working_time.value,
            );
            this.tableData.records[findTotalRowIndex].order_value.value += Number(record.order_value.value);
            this.tableData.records[findTotalRowIndex].average_check.value += Number(record.average_check.value);
            this.tableData.records[findTotalRowIndex].travel_time_calculation.value = this.sumTime(
              this.tableData.records[findTotalRowIndex].travel_time_calculation.value,
              record.travel_time_calculation.value,
            );
            this.tableData.records[findTotalRowIndex].actual_travel_time.value = this.sumTime(
              this.tableData.records[findTotalRowIndex].actual_travel_time.value,
              record.actual_travel_time.value,
            );
            this.tableData.records[findTotalRowIndex].kpi.value += Number(record.kpi.value);
            this.tableData.records[findTotalRowIndex].idle_time.value += Number(record.idle_time.value);
            this.tableData.records[findTotalRowIndex].time.value += Number(record.time.value);
            this.tableData.records[findTotalRowIndex].sum_orders.value += Number(record.sum_orders.value);
            this.tableData.records[findTotalRowIndex].money_per_distance.value += Number(record.money_per_distance.value);

            this.tableData.records[findTotalRowIndex].orders.value += Number(record.orders.value);
            this.tableData.records[findTotalRowIndex].distance.value += Number(record.distance.value);
            this.tableData.records[findTotalRowIndex].late_checkout_surcharge.value += Number(
              record.late_checkout_surcharge.value,
            );
            this.tableData.records[findTotalRowIndex].short_shift_allowance.value += Number(
              record.short_shift_allowance.value,
            );
            this.tableData.records[findTotalRowIndex].prize.value += Number(record.prize.value);
            this.tableData.records[findTotalRowIndex].fine.value += Number(record.fine.value);
            this.tableData.records[findTotalRowIndex].total_accrued.value += Number(record.total_accrued.value);
            this.tableData.records[findTotalRowIndex].already_paid.value += Number(record.already_paid.value);
            this.tableData.records[findTotalRowIndex].to_payoff.value += Number(record.to_payoff.value);
            this.tableData.records[findTotalRowIndex].personal_account_accrued.value += Number(record.personal_account_accrued.value);
            this.tableData.records[findTotalRowIndex].personal_account_removed.value += Number(record.personal_account_removed.value);
            this.tableData.records[findTotalRowIndex].balance.value += Number(record.balance.value);
            this.tableData.records[findTotalRowIndex].personal_account_transactions.value += Number(record.personal_account_transactions.value);

            this.tableData.records[findTotalRowIndex].count_smenas.value += Number(record.count_smenas.value);
            this.tableData.records[findTotalRowIndex].sum_deposit.value += Number(record.sum_deposit.value);
            this.tableData.records[findTotalRowIndex].allowance.value += Number(record.allowance.value);

          }
        });

        const idle_time = (
          this.tableData.records[findTotalRowIndex].idle_time.value /
          (this.tableData.records.length - 1)
        ).toFixed(2);

        this.tableData.records[findTotalRowIndex].distance.value = this.tableData.records[findTotalRowIndex].distance.value.toFixed(2);

        this.tableData.records[findTotalRowIndex].average_check.value = this.tableData.records[findTotalRowIndex].orders.value>0 ? Math.round(this.tableData.records[findTotalRowIndex].order_value.value / this.tableData.records[findTotalRowIndex].orders.value) : 0;

        this.tableData.records[findTotalRowIndex].idle_time.value =
          this.tableData.records[findTotalRowIndex].idle_time.value > 0 ? idle_time : 0;
        this.tableData.records[findTotalRowIndex].kpi.value =
          this.tableData.records[findTotalRowIndex].kpi.value > 0
            ? (this.tableData.records[findTotalRowIndex].kpi.value / (this.tableData.records.length - 1)).toFixed(2)
            : 0;
      }
    },

    sumTime(t1, t2) {
      let hh1 = 0;
      let mm1 = 0;
      let hh2 = 0;
      let mm2 = 0;

      let resultHH = 0;
      let resultMM = 0;
      if (t1 === 0) {
        hh1 = 0;
        mm2 = 0;
      } else if (typeof t1 !== "number") {
        hh1 = Number(t1.split(":")[0]);
        mm1 = Number(t1.split(":")[1]);
      }

      if (t2 === 0) {
        hh1 = 0;
        mm2 = 0;
      } else if (typeof t1 !== "number") {
        hh2 = Number(t2.split(":")[0]);
        mm2 = Number(t2.split(":")[1]);
      }

      resultHH = hh1 + hh2;
      resultMM = mm1 + mm2;
      if (resultMM > 59) {
        resultMM -= 60;
        resultHH += 1;
      }

      if (resultHH < 10) {
        resultHH = `0${resultHH}`;
      }

      if (resultMM < 10) {
        resultMM = `0${resultMM}`;
      }

      return `${resultHH}:${resultMM}`;
    },

    collectCalculation() {
      if (this.tab === "byPeriod") {
        const total = {sum:0, sum_round:0, sum_paid:0};

        const workers = [];
        this.tableData.records
          .filter((record) => !record.isTotalRow)
          .forEach((record) => {
            total.sum += record.to_payoff.value;
            total.sum_round += record.to_payoff.value;
            total.sum_paid += -record.personal_account_transactions.value;
            workers.push({
              author_bonus: 0,
              author_fine: 0,
              bonus_id: 0,
              bonuses: record.prize.items.map((item) => ({
                amount: item.amount,
                author_id: item.author_id,
                is_external: item.is_external,
                reason: item.reason,
                reason_id: item.reason_id,
              })),
              count_smenas: record.count_smenas.value,
              departure: 0,
              distance: record.distance.value,
              duration: record.actual_travel_time.valueInDecimal,
              fine_id: 0,
              fines: record.fine.items.map((item) => item),
              orders: record.orders.value,
              orders_sum: record.order_value.value,
              personal: -record.personal_account_transactions.value,
              personal_history: record.personal_account_transactions.items.map((item) => ({
                type: item.type,
                amount: Number(item.amount),
                comment: item.comment,
                authorName: "vpadmin",
                reason: "",
                reason_id: item.reason_id,
              })),
              plan_duration: record.travel_time_calculation.valueInDecimal,
              reason_surcharge_id: null,
              routes: 0,
              showname: record.employee.value,
              sum: Math.round(record.total_accrued.value*100)/100,
              sum_bonus: record.prize.value,
              sum_calc: 0,
              sum_departure: record.late_checkout_surcharge.value,
              sum_deposit: 0,
              sum_distance: record.money_per_distance.value,
              plus: record.account_accrued,
              minus: record.account_removed,
              sum_duration: 0,
              sum_min: record.minimum_wage.value,
              sum_orders: record.order_value.value,
              sum_paid: -record.personal_account_transactions.value,
              sum_penalty: record.fine.value,
              sum_prepay: record.personal_account_removed.value,
              sum_deposit: record.sum_deposit.value,
              balance: record.balance.value,
              sum_round: Math.round(record.total_accrued.value*100)/100,
              sum_short_shift: record.short_shift_allowance.value,
              sum_surcharge: record.allowance.value,
              worker_id: record.id,
              worktime: record.worktime,
            });
          });
        this.data.period.drivers.workers = workers;
        Object.entries(this.data.period.production).forEach(([key, value]) => {
          if (key !== "workers" && key !== "posts") {
            this.data.period.production[key] = value !== null ? value : 0;
          }
        });
        //        this.data.period.drivers.sum = total.sum;
        //      this.data.period.drivers.sum_round = total.sum_round;
        //    this.data.period.drivers.sum_paid = total.sum_paid;

        Object.entries(this.data.period.drivers).forEach(([key, value]) => {
          if (key !== "workers") {
            this.data.period.drivers[key] = value !== null ? value : 0;
          }
        });
      } else {
        // save calc by date
      }
    },

    cancelCalculation() {
      this.$emit("cancelCalculation");
    },

    saveCalculation() {
      this.collectCalculation();
      this.$emit("saveCalculation");
    },
  },
};
</script>

<style lang="scss" scoped>
@import "~@/assets/styles/vars";
.delivery {
  margin-top: 30px;

  &-header {
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;

    &-buttons-left {
      display: flex;
      align-items: center;
      margin-right: 10px;
      margin-bottom: 10px;

      &-drivers {
        &-disabled {
          opacity: 0.5;
          pointer-events: none !important;
        }

        ::v-deep .c-button__dropdown__container__list__item__label {
          white-space: nowrap;
        }
        ::v-deep .c-button__dropdown__container {
          max-width: 210px;
        }
      }

      &-recalculate-routes {
        margin-left: 10px;
      }

      &-fine-rewarding {
        margin-left: 10px;
      }

      &-holiday-allowance {
        margin-left: 31px;
        display: flex;
        align-items: center;

        &-percent {
          margin-left: 15px;
        }
      }
    }

    &-buttons-right {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      &-less {
        margin-left: 10px;
      }

      &-more {
        margin-left: 10px;
      }
    }
  }

  &-table {
    margin-top: 14px;
  }

  &-loader {
    margin-top: 14px;
  }

  &-actions {
    height: 58px;
    padding: 10px 0 10px 30px;
    position: sticky;
    bottom: -6px;
    right: 0;
    box-shadow: 0 -6px 4px -4px #00000025;
    background-color: #fff;
    transition: all 150ms ease;
    justify-content: flex-end;
    z-index: 70;
    margin-top: 20px;

    &.no-shadow {
      box-shadow: none !important;
    }

    @include onlyStandartMobile {
      width: 100vw;
      position: static;
      height: auto;
      padding: 0;
      box-shadow: none;
    }
  }

  &-actions-row {
    display: flex;
    align-items: center;
    gap: 10px;
    height: 58px;
    padding: 10px 0 10px 30px;
    position: sticky;
    bottom: -6px;
    right: 0;
    box-shadow: 0 -6px 4px -4px #00000025;
    background-color: #fff;
    transition: all 150ms ease;
    justify-content: flex-end;
    z-index: 70;
    margin-top: 20px;

    @include onlyStandartMobile {
      width: 100vw;
      position: static;
      height: auto;
      padding: 0;
      box-shadow: none;
      flex-wrap: wrap;
    }

    &__toggle-closed--active {
      background-color: #fff !important;
      border-color: #f56c6c !important;
      color: #f56c6c !important;

      &:hover {
        border-color: #e04040 !important;
        color: #e04040 !important;
      }
    }

    &__closed-badge {
      display: inline-block;
      padding: 6px 14px;
      border-radius: 4px;
      background-color: #f56c6c;
      color: #fff;
      font-size: 13px;
      font-weight: 600;
      white-space: nowrap;
    }

    .delivery-actions {
      margin-top: 0;
      position: static;
      box-shadow: none;
      height: auto;
      padding: 0;
      background: none;
    }
  }
}
</style>
